import React from 'react';
// import innban from '../assets/images/inner-banner.jpg';
import about from '../assets/images/about-banner.jpg';

const InnerBanner = () => {
  return (
    <>

    <div className="bannermn">
        <img src={about} alt="Banner" />
    </div>      
    </>
  );
};

export default InnerBanner;